import { useMemo } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import Slider from 'react-slick'

import ImageType from '../types/ImageType'
import Arrow from './Arrow'
import ImageSlide from './ImageSlide'
import { BlockSectionTitle, BlockWrapper, Container } from 'common/widgets'
import classNames from './styles.module.scss'


TwoColumnCarousel.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string,
    heading_hx: PropTypes.string,
    images: PropTypes.arrayOf(ImageType),
  }),
  priorityLoad: PropTypes.bool,
}

const settings = {
  arrows: true,
  infinite: false,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
  nextArrow: <Arrow position="right" />,
  prevArrow: <Arrow position="left" />,
}

export default function TwoColumnCarousel({
  data = {
    images: [],
  },
  priorityLoad = false,
}) {
  const slides = useMemo(() => get(data, 'images', []).map((img, index) => (
    <ImageSlide
      key={index}
      image={img}
      priority={priorityLoad && index < 2}
    />
  )), [data?.images])

  return (
    <BlockWrapper>
      <Container size="xl">
        <BlockSectionTitle heading={data.heading} headingHx={data.heading_hx} />
        <Slider {...settings} className={classNames.slider}>
          {slides}
        </Slider>
      </Container>
    </BlockWrapper>
  )
}
